import { ApiUrl } from '@common/enums';
import { MaterialsAPIItem } from '@common/models/material.model';
import { MaterialsQueryParams } from '@ee-api/queryParams';

import { easyEstimatorApi } from '../easyEstimatorService';

const materialsApi = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchMaterials: builder.query<MaterialsAPIItem[], MaterialsQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.MATERIALS,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchMaterialsQuery, useLazyFetchMaterialsQuery } = materialsApi;
